import { useTranslation } from "react-i18next";
import { articles } from "@/mocks/articles";

export default function FaqSection() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language === "pl" || i18n.language === "es" || i18n.language === "fr" ? i18n.language : "en";
  const content = articles[0].content[lang] ?? articles[0].content.en;

  return (
    <section id="faq" className="bg-background-100/60">
      <div className="mx-auto max-w-3xl px-4 md:px-6 py-16">
        <div className="text-center mb-10">
          <h2 className="font-heading font-semibold text-2xl md:text-4xl text-foreground-950">{t("faq.title")}</h2>
          <p className="mt-3 text-foreground-600">{t("faq.subtitle")}</p>
        </div>

        <div className="space-y-3">
          {content.faq.map((item, i) => (
            <details key={i} className="group rounded-lg bg-background-50 border border-background-200 overflow-hidden">
              <summary className="flex items-center justify-between gap-4 px-5 py-4 cursor-pointer list-none">
                <span className="text-sm font-semibold text-foreground-900">{item.q}</span>
                <span className="w-6 h-6 flex items-center justify-center rounded-full bg-background-100 text-foreground-500 group-open:rotate-45 transition-transform shrink-0">
                  <i className="ri-add-line" />
                </span>
              </summary>
              <p className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">{item.a}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}